<div class="w-100 d-flex flex-column align-items-center justify-content-start text-center">
  <p class="widgetTitle mb-2" [innerHTML]="'widget.widget_title' | translate "></p>
  <!-- ======= counter ======= -->

  <div class="w-100 counter">
    <div class="d-flex align-items-center justify-content-center w-100 gap-2 px-3">
      <div class="time-card text-center d-flex" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
        <div class="indicator">{{ 'widget.days' | translate }}</div>
        <div class="value">{{ liveCounter._days }}</div>
      </div>
      <div class="time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
        <div class="indicator">{{ 'widget.hours' | translate }}</div>
        <div class="value">{{ liveCounter._hours }}</div>
      </div>
      <div class="time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
        <div class="indicator">{{ 'widget.minutes' | translate }}</div>
        <div class="value">{{ liveCounter._minutes }}</div>
      </div>
      <div class="time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
        <div class="indicator">{{ 'widget.seconds' | translate }}</div>
        <div class="value">{{ liveCounter._seconds }}</div>
      </div>
    </div>
    <div class="progress mt-1" data-percent="0" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
      <div class="bar" [style.width]="raisedInfo.raisedPercent"></div>
      <div class="status" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">{{ 'widget.bar_title' | translate }}</div>
    </div>
  </div>

  <p class="my-2 text-center fw-bold" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <span class="text-uppercase fs-8"> {{ 'widget.usdt_raised' | translate }} = </span>
    <span class="fs-7">${{ convertNum(raisedInfo.usdRaised) }} / ${{ convertNum(raisedInfo.maxAmount) }}</span>
  </p>

  <!-- <div class="progress" data-percent="0" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <div class="bar" [style.width]="raisedInfo.raisedPercent"></div>
    <div class="status" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">{{ 'widget.bar_title' | translate }}</div>
  </div> -->

  <div *ngIf="walletAddress" class="d-flex justify-content-center align-items-start text-center font-12 mb-2" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <span class="text-uppercase">{{ 'widget.your_claimable' | translate: { tokenName } }}</span>
    <span class="text-light"> = {{ convertNum(raisedInfo.userStaked + raisedInfo.userClaimable) }}</span>
    <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer wx-15" (click)="yourPurchasedInfo()" alt="More Information" />
  </div>

  <div *ngIf="walletAddress" class="d-flex justify-content-center align-items-start text-center font-12 mb-2" [ngClass]="[!raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 ? 'shimmer' : '']">
    <span class="text-uppercase">{{ 'widget.your_stakeable' | translate: { tokenName } }}</span>
    <span class="fw-regular text-light"> = {{ convertNum(raisedInfo.userEthClaimable) }}</span>
    <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer wx-15" (click)="stakeInfo()" alt="More Information" />
  </div>

  <button type="button" class="btn btn-secondary mb-4 mt-2 mx-auto" (click)="referAndEarn()" *ngIf="walletAddress && referUrl != ''">{{ 'widget.refer_and_earn' | translate }}</button>
</div>
